import ValidateCertificates from './ValidateCertificates';

export default ValidateCertificates;
